import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const initial = { name: "", company: "", email: "", phone: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const update = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in your name, email, and message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Thank you. Your message has been received — we'll be in touch.");
      setForm(initial);
    } catch (err) {
      toast.error("Something went wrong. Please email adam@slatechsolutions.com directly.");
    } finally {
      setLoading(false);
    }
  };

  const fieldClass =
    "w-full bg-transparent border border-zinc-700 focus:border-blue-500 outline-none px-4 py-3.5 text-white placeholder:text-zinc-500 transition-colors duration-200 font-sans";

  return (
    <form data-testid="contact-form" onSubmit={submit} className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
            Name *
          </label>
          <input
            data-testid="contact-name"
            name="name"
            value={form.name}
            onChange={update}
            placeholder="Your name"
            className={fieldClass}
          />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
            Company
          </label>
          <input
            data-testid="contact-company"
            name="company"
            value={form.company}
            onChange={update}
            placeholder="Company name"
            className={fieldClass}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div>
          <label className="block text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
            Email *
          </label>
          <input
            data-testid="contact-email"
            name="email"
            type="email"
            value={form.email}
            onChange={update}
            placeholder="you@company.com"
            className={fieldClass}
          />
        </div>
        <div>
          <label className="block text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
            Phone
          </label>
          <input
            data-testid="contact-phone"
            name="phone"
            value={form.phone}
            onChange={update}
            placeholder="(000) 000-0000"
            className={fieldClass}
          />
        </div>
      </div>

      <div>
        <label className="block text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-2">
          Tell us about your challenge *
        </label>
        <textarea
          data-testid="contact-message"
          name="message"
          value={form.message}
          onChange={update}
          rows={5}
          placeholder="What are you trying to solve, source, or connect?"
          className={`${fieldClass} resize-none`}
        />
      </div>

      <button
        data-testid="contact-submit"
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center gap-2.5 font-heading text-base font-semibold uppercase tracking-widest bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white px-8 py-4 transition-colors duration-200 w-full sm:w-auto"
      >
        {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={18} />}
        {loading ? "Sending..." : "Start the Conversation"}
      </button>
    </form>
  );
};
